"use strict";
import React from "react";
import {
    BrowserRouter,
    Route,
    Routes,
    useLocation,
    useParams,
    Navigate as RouterNavigate,
} from "react-router-dom";
import Header from "./Header";
import { Box, Stack } from "@mui/material";
import SigninScreen from "../Screens/SigninScreen";
import ForgotPasswordScreen from "../Screens/ForgotPassword.js";
import SignupScreen from "../Screens/SignupScreen";
import UserListScreen from "../Screens/UserListScreen";
import TeamListScreen from "../Screens/TeamListScreen";
import TeamCreateScreen from "../Screens/TeamCreateScreen";
import TeamEditScreen from "../Screens/TeamEditScreen";
import UserEditScreen from "../Screens/UserEditScreen";
import ResultsScreen from "../Screens/ResultsScreen";
import LandingAdminPage from "../Screens/LandingAdminPage";
// import ProjectCreationScreen from "../Screens/ProjectCreationScreen";
import ProjectCreationStartScreen from "../Screens/ProjectCreationStartScreen";
import ProjectCreationDetailsScreen from "../Screens/ProjectCreationDetailsScreen";
import ProjectListScreen from "../Screens/ProjectListScreen";
import LandingPage from "../Screens/LandingPage";
import ProjectEditScreen from "../Screens/ProjectEditScreen";
import TranscriberScreen from "../Screens/WorkScreens/TranscriberScreen";
import QAScreen from "../Screens/WorkScreens/QAScreen";
import AttributionScreen from "../Screens/WorkScreens/AttributionScreen";
import TranslatorScreen from "../Screens/WorkScreens/TranslatorScreen.js";
import ActionsScreen from "../Screens/ActionsScreen.js";
import WorkPagesScreen from "../Screens/WorkPagesScreen.js";
import LipSyncOutputScreen from "../Screens/WorkScreens/LipSyncOutputScreen.js";
import VideoPerformanceDirection from "../Screens/WorkScreens/VideoPerformanceDirection.js";
import VideoPerformanceDirectionVersions from "../Screens/WorkScreens/VideoPerformanceDirectionVersions.js";
import ProjectDetailsScreen from "../Screens/ProjectDetailsScreen.js";
import AudiobookListScreen from "../Screens/Audiobook/AudiobookListScreen.js";
import AudiobookWorkPages from "../Screens/Audiobook/AudiobookWorkPages.js";
import AudiobookPerformanceDirection from "../Screens/Audiobook/AudiobookPerformanceDirection.js";
import Footer from "./Footer.js";
import AdminRoute from "../Components/Validations/AdminRoute.js";
import ProtectedRoute from "../Components/Validations/ProtectedRoute.js";
import ProjectRoute from "../Components/Validations/ProjectRoute.js";
import AudiobookEditPage from "../Screens/Audiobook/AudiobookEditPage.js";
import AudiobookDetailsPage from "../Screens/Audiobook/AudiobookDetailsPage.js";
import AudiobookActionsScreen from "../Screens/Audiobook/AudiobookActionsScreen.js";
import SimpleVideoPlayerDemo from "../Screens/Demos/SimpleVideoPlayerDemo.js";
import UserProfile from "../Components/UserProfile/index.js";
import ProjectSidebar from "./ProjectSidebar.js";
import { backgroundWellSx } from "../theme.js";
import Api from "../Screens/Api/Api.js";

import CharacterCustomizationScreen from "../Screens/CharacterCustomizationScreen.js";
import FileUploadScreen from "../Screens/FileUploadScreen.js";
import CreateProjectsScreen from "../Screens/CreateProjectsScreen.js";
import ProjectVoicesScreen from "../Screens/ProjectVoicesScreen.js";

// Keeps old /voice-mixing links working after the page became Character Customization.
const VoiceMixingRedirect = () => {
    const { id } = useParams();
    const location = useLocation();
    return (
        <RouterNavigate
            to={`/projects/${id}/character-customization`}
            state={location.state}
            replace
        />
    );
};

const MainContent = () => {
    const location = useLocation();
    const isApiPage = location.pathname.startsWith("/api");
    return (
        <Stack direction="row" sx={backgroundWellSx}>
            {!isApiPage && <ProjectSidebar />}
            <Box sx={{ flexGrow: 1 }}>
                <Routes>
                    <Route path="/demo/simple-video" element={<SimpleVideoPlayerDemo />} />
                    <Route path="/api/*" element={<Api />} />

          <Route
            path="/adminlanding"
            element={
              <AdminRoute>
                <LandingAdminPage />
              </AdminRoute>
            }
          />
          <Route path="/landing" element={<LandingPage />} />
          <Route
            path="/work/translator/:language"
            element={
                <ProjectRoute>
                    <TranslatorScreen />
                </ProjectRoute>
            }
          />
          <Route
            path="/work/performancedirection/:language"
            element={
                <ProjectRoute>
                    <VideoPerformanceDirection />
                </ProjectRoute>
            }
          />
          <Route
            path="/work/performancedirectionversions/:language"
            element={
                <ProjectRoute>
                    <VideoPerformanceDirectionVersions />
                </ProjectRoute>
            }
          />
          <Route
            path="/work/attribution"
            element={
                <ProjectRoute>
                    <AttributionScreen />
                </ProjectRoute>
            }
          />
          <Route
            path="/work/transcriber"
            element={
                <ProjectRoute>
                    <TranscriberScreen />
                </ProjectRoute>
            }
          />
          <Route
            path="/work/lipqualityassurance/:language"
            element={
                <ProjectRoute>
                    <LipSyncOutputScreen />
                </ProjectRoute>
            }
          />
          <Route
            path="/work/qualityassurance/:language"
            element={
                <ProjectRoute>
                    <QAScreen />
                </ProjectRoute>
            }
          />
          <Route path="/" element={<SigninScreen />} />
          <Route path="/signup" element={<SignupScreen />} />
          <Route path="/forgotpassword" element={<ForgotPasswordScreen />} />

          <Route
            path="/admin/users"
            element={
              <AdminRoute>
                <UserListScreen />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/teams"
            element={
              <AdminRoute>
                <TeamListScreen />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/teams/new"
            element={
              <AdminRoute>
                <TeamCreateScreen />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/teams/:teamId/edit"
            element={
              <AdminRoute>
                <TeamEditScreen />
              </AdminRoute>
            }
          />

          <Route
            path="/userprofile"
            element={
              <UserProfile></UserProfile>
            }
          />

          <Route
            path="/admin/user/:id"
            element={
              <AdminRoute>
                <UserEditScreen />
              </AdminRoute>
            }
          />
          <Route path="/results/:id" element={<ResultsScreen />} />
          <Route
            path="/workpages/:id"
            element={
              <AdminRoute>
                <WorkPagesScreen />
              </AdminRoute>
            }
          />
          <Route
            path="/workpages/details/:id"
            element={
              <ProjectRoute>
                <ProjectDetailsScreen />
              </ProjectRoute>
            }
          />
          <Route
            path="/actions/:id"
            element={
              <AdminRoute>
                <ActionsScreen />
              </AdminRoute>
            }
          />
          {/* <Route
            path="/createproject"
            element={
              <AdminRoute>
                <ProjectCreationScreen />
              </AdminRoute>
            }
          /> */}

          <Route
            path="/createproject"
            element={
              <AdminRoute>
                <ProjectCreationStartScreen />
              </AdminRoute>
            }
          />
          <Route
            path="/project-creation-details"
            element={
              <AdminRoute>
                <ProjectCreationDetailsScreen />
              </AdminRoute>
            }
          />
          
          <Route
            path="/file-upload"
            element={
              <FileUploadScreen />
            }
          />

          <Route
            path="/createprojects"
            element={
              <CreateProjectsScreen />
            }
          />

          <Route
            path="/admin/videoprojects"
            element={
              <AdminRoute>
                <ProjectListScreen />
              </AdminRoute>
            }
          />
          <Route
            path="/projectlist"
            element={<RouterNavigate to="/admin/videoprojects" replace />}
          />
          <Route
            path="/projects/:id/manage"
            element={
              <AdminRoute>
                <ProjectEditScreen />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/audioprojects"
            element={
              <AdminRoute>
                <AudiobookListScreen />
              </AdminRoute>
            }
          />

          <Route
            path="/audiobooks/edit/:id"
            element={
              <AdminRoute>
                <AudiobookEditPage /> {/* You might want to create an AudiobookEditScreen */}
              </AdminRoute>
            }
          />

          <Route
            path="/audiobooks/performancedirection/:projectId/:language"
            element={
                <ProtectedRoute>
                    <ProjectRoute>
                        <AudiobookPerformanceDirection />
                    </ProjectRoute>
                </ProtectedRoute>
            }
          />
          <Route
            path="/audiobooks/workpages/:projectId"
            element={
              <AdminRoute>
                <AudiobookWorkPages /> {/* You might want to create an AudiobookDetailsScreen */}
              </AdminRoute>
            }
          />
          <Route
            path="/audiobooks/details/:projectId"
            element={
              <ProjectRoute>
                <AudiobookDetailsPage />
              </ProjectRoute>
            }
          />
          <Route
            path="/audiobooks/actions/:projectId"
            element={
              <AdminRoute>
                <AudiobookActionsScreen />
              </AdminRoute>
            }
          />

          <Route
            path="/projects/:id/character-customization"
            element={
              <ProtectedRoute>
                <ProjectRoute>
                  <CharacterCustomizationScreen />
                </ProjectRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/:id/voice-mixing"
            element={<VoiceMixingRedirect />}
          />

          <Route
            path="/projects/:id/voices"
            element={
              <ProjectRoute>
                <ProjectVoicesScreen />
              </ProjectRoute>
            }
          />

                </Routes>
            </Box>
        </Stack>
    );
};

const Navigate = () => {
    return (
        <BrowserRouter>
            <Header />
            <MainContent />
            <Footer />
        </BrowserRouter>
    );
};

export default Navigate;
